import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { GuardLayout } from "@/components/Organisms";
import { useAuthStore } from "@/stores/auth.store";

export const Route = createFileRoute("/_guard")({
  beforeLoad: ({ location }) => {
    const isAuthenticated = useAuthStore.getState().isAuthenticated;
    if (!isAuthenticated) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: () => (
    <GuardLayout>
        <Outlet />
      </GuardLayout>
  ),
});
